/*
 * Copyright (c) 2025 Pegasystems Inc.
 * All rights reserved.
 */

import Validator from '../validator';
import type { AttachmentObject, FileResponseObject } from '../../attachment/types';

const getErrorMessage = (attachments: FileResponseObject[]) => {
  const errorMessage = 'Error with one or more files';
  for (const attachment of attachments) {
    if (attachment?.error) {
      return errorMessage;
    }
  }
  return null;
};

Validator.register('attachment', (value: AttachmentObject | FileResponseObject | FileResponseObject[]) => {
  let message: string | null = null;
  const errorMessage = 'Error with one or more files';
  if (!value) {
    return message;
  }

  if ('pyCount' in value && Array.isArray(value.pxResults)) {
    // Old attachment structure
    message = getErrorMessage(value.pxResults);
  } else if (Array.isArray(value)) {
    message = getErrorMessage(value);
  } else if ('error' in value && !!value.error) {
    message = errorMessage;
  } else {
    // Sonar fix
  }
  return message;
});
